<template>
  <div>
    <div class="card-header">
      <div class="d-flex justify-content-end gap-2 align-items-center flex-wrap">
        <div class="referral-filter">
          <multi-select
            v-model="filterTags"
            tag-placeholder="Tags"
            :placeholder="$t('tags')"
            label="name"
            :options="tags"
            track-by="name"
            :multiple="true"
          />
        </div>
        <div>
          <input
            autocomplete="off"
            type="text"
            name="search"
            class="form-control"
            :placeholder="$t('search')"
            v-model="search"
          />
        </div>
        <button
          @click="openModal('add')"
          class="btn btn-primary d-flex align-items-center gap-1 ms-auto md-mt-0 mt-0"
          v-if="$can('backoffice-referral-link.create') && !isShow"
        >
          <feather-icon :icon="'AddIcon'" size="12" />
          <span>{{ $t("createReferralLinks") }}</span>
        </button>
      </div>
    </div>
    <div class="card-body">
      <!--==================================-->
      <div class="dextop-table-view">
        <!-- table -->
        <div class="table-responsive api-keys-table">
          <vue-good-table
            styleClass="vgt-table striped"
            :columns="columns"
            :fixed-header="false"
            :rows="rows"
            :pagination-options="{
              enabled: false,
              perPage: pageLength,
            }"
            mode="remote"
            @on-page-change="onPageChange"
            @on-sort-change="onSortChange"
            @on-per-page-change="onPerPageChange"
          >
            <div slot="emptystate" style="text-align: center">
              {{ $t("noDataForTable") }}
            </div>
            <template slot="table-row" slot-scope="props">
              <!-- Column: Name -->

              <span
                class="d-flex align-items-center justify-content-center gap-2"
                v-if="props.column.field === 'action' && !props.row.isDefault"
              >
                <div
                  class="cursor-pointer"
                  @click="openModal('edit', props.row)"
                  v-if="$can('backoffice-referral-link.edit')"
                >
                  <feather-icon size="16" icon="Edit2Icon" />
                </div>
                <div
                  class="cursor-pointer"
                  @click="destroy(props.row.id)"
                  v-if="$can('backoffice-referral-link.delete')"
                >
                  <feather-icon size="16" icon="TrashIcon" />
                </div>
              </span>
              <span
                v-else-if="
                  props.column.field === 'link' && props.row.isActivate
                "
              >
                {{
                  `${referralServiceBaseUrl}/register?referralId=${props.row.referralId}`
                }}
                <feather-icon
                  icon="CopyIcon"
                  class="cursor-pointer text-primary"
                  @click="
                    copyToClipboard(
                      `${referralServiceBaseUrl}/register?referralId=${props.row.referralId}`
                    )
                  "
                />
              </span>
              <span v-else-if="props.column.field === 'tags'">
                <span
                  v-for="(tag, index) in formatTags(props.row.tags)"
                  :key="index"
                  class="badge bg-success me-1"
                >
                  {{ tag }}
                </span>
              </span>
              <span v-else-if="props.column.field === 'users'">
                <span
                  v-for="(user, index) in props.row.users"
                  :key="index"
                  class="user-name"
                >
                  {{
                    (userProfiles[user.userId].first_name || "") +
                    " " +
                    (userProfiles[user.userId].last_name || "")
                  }}
                  <span
                    v-if="index !== props.row.users.length - 1"
                    class="separator"
                    >•</span
                  >
                </span>
              </span>
              <span v-else-if="props.column.field === 'isActivate'">
                <span>
                  {{ props.row.isActivate ? "Activated" : "Deactivated" }}
                </span>
              </span>
              <!-- Column: Common -->
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <b-form-group>
            <div class="d-flex align-items-center">
              <span class="text-nowrap"> {{ $t("rowsPerPage") }} </span>
              <b-form-select
                v-model="pageLength"
                :options="['25', '50', '100']"
                class="ml-1"
                @input="(value) => onPerPageChange({ pageLength: value })"
              />
            </div>
          </b-form-group>
          <div>
            <b-pagination
              :value="1"
              :total-rows="totalRecords"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => onPageChange({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </div>
      <!--==================================-->
      <!--==================================-->
      <div class="reponsive-view-cards">
        <b-row>
          <b-col cols="12" lg="4" md="6" v-for="row in rows" :key="row.id">
            <div class="card">
              <div class="card-header">
                <h4 class="">{{ row.name }}</h4>
                <div class="d-flex gap-2">
                  <feather-icon
                    class="cursor-pointer"
                    @click="openModal('edit', row)"
                    v-if="$can('backoffice-referral-link.edit')"
                    size="18"
                    icon="Edit2Icon"
                  />
                  <feather-icon
                    class="cursor-pointer"
                    @click="destroy(row.id)"
                    v-if="$can('backoffice-referral-link.delete')"
                    size="18"
                    icon="TrashIcon"
                  />
              </div>
            </div>
              <div class="card-body">
                <ul class="card-list">
                  <li>
                    <div class="left">
                      <strong>{{ $t("tags") }}: </strong>
                    </div>
                    <div class="right">
                      <span
                        v-for="(tag, index) in formatTags(row.tags)"
                        :key="index"
                        class="badge bg-success me-1"
                      >
                        {{ tag }}
                      </span>
                    </div>
                  </li>
                  <li>
                    <div class="left">
                      <strong>{{ $t("users") }}: </strong>
                    </div>
                    <div class="right">
                      <span
                        v-for="(user, index) in row.users"
                        :key="index"
                        class="user-name"
                      >
                        {{
                          (userProfiles[user.userId].first_name || "") +
                          " " +
                          (userProfiles[user.userId].last_name || "")
                        }}
                        <span
                          v-if="index !== row.users.length - 1"
                          class="separator"
                          >•</span
                        >
                      </span>
                    </div>
                  </li>
                  <li>
                    <div class="left">
                      <strong>{{ $t("link") }}: </strong>
                    </div>
                    <div v-if="row.isActivate" class="right">
                      <span class="d-flex align-items-center gap-2">{{
                        `${referralServiceBaseUrl}/register?referralId=${row.referralId}`
                      }}</span>
                      <feather-icon
                        icon="CopyIcon"
                        class="cursor-pointer text-primary"
                        @click="copyToClipboard(`${referralServiceBaseUrl}/register?referralId=${row.referralId}`)"
                      />
                    </div>
                  </li>
                  <li>
                    <div class="left">
                      <strong>{{ $t("status") }}: </strong>
                    </div>
                    <div class="right">
                      <span>
                        {{ row.isActivate ? "Activated" : "Deactivated" }}
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </b-col>
          <b-col cols="12">
            <div class="d-flex justify-content-center mt-2">
              <b-pagination
                :value="1"
                :total-rows="totalRecords"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mb-0"
                @input="(value) => onPageChange({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </b-col>
        </b-row>
      </div>
      <!--==================================-->
      <!--==================================-->
    </div>
    <b-modal
      id="edit-tag-modal"
      v-model="showModal"
      :title="
        modalType === 'add' ? 'Create Referral Link' : 'Edit Referral Link'
      "
      centered
      size="lg"
      hide-footer
    >
      <validation-observer ref="referralLinkRules">
        <b-row>
          <b-col cols="12" md="6">
            <validation-provider
              #default="{ errors }"
              name="Name"
              rules="required"
            >
              <TextInput
                v-model="referralLinks.name"
                :label="$t('name')"
                :tooltipMessage="$t('name')"
                :required="true"
                :error="errors[0]"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col cols="12" md="6">
            <label class="form-label input-label" for="Tags"
              >{{ $t("tags") }}
            </label>
            
              <multi-select
                v-model="referralLinks.tags"
                :taggable="true"
                tag-placeholder="Add a tag"
                :placeholder="$t('selectOrAddATag')"
                @tag="addTag"
                label="name"
                :options="[]"
                track-by="name"
                :multiple="true"
              />
          </b-col>
          <b-col cols="12" md="6">
            <label class="input-label form-label" for="cars">
              {{ $t("users") }}
            </label>
            <MultiSelectInput
              v-model="referralLinks.users"
              :options="modifiedUsers"
              :label="'full_name'"
              trackBy="id"
              :key="referralLinks.users"
              moduleName="users"
              :multiple="true"
              :searchParamName="`search_string`"
              ><template #option="{ props }">
                <div>
                  <p>
                    {{ props.option.first_name }} {{ props.option.last_name }}
                  </p>
                </div>
              </template>
            </MultiSelectInput>
          </b-col>
          <b-col cols="12" md="6">
            <div class="checkbox-group d-inline-block mt-2">
              <input
                id="isActivate"
                class="checkbox-input"
                v-model="referralLinks.isActivate"
                type="checkbox"
                name="isActivate"
              />
              <label class="checkbox-label" for="isActivate">{{
                $t("activate")
              }}</label>
            </div>
          </b-col>
        </b-row>
        <div class="d-flex align-items-center justify-content-end mt-2">
          <b-button class="mr-1" @click="showModal = false" variant="primary"
            ><feather-icon :icon="'XIcon'" size="10" />{{
              $t("cancel")
            }}</b-button
          >
          <b-button
            v-if="
              modalType === 'add' && $can(`backoffice-referral-link.create`)
            "
            @click="saveReferralLink()"
            variant="primary"
            :disabled="isReferralLinkFormInvalid"
            ><feather-icon :icon="'PlusIcon'" size="10" />{{
              $t("create")
            }}</b-button
          >
          <b-button
            v-else-if="$can(`backoffice-referral-link.edit`)"
            @click="editReferralLink()"
            variant="primary"
            :disabled="isReferralLinkFormInvalid"
            ><feather-icon :icon="'PlusIcon'" size="10" />{{
              $t("update")
            }}</b-button
          >
        </div>
      </validation-observer>
    </b-modal>
    <!--==================================-->
  </div>
</template>

<script>
import TextInput from "@/components/TextInput.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { debounce } from "@/utils/debounce";
import MultiSelectInput from "@/components/MultiSelectInput.vue";
import { mapGetters } from "vuex";
import { required, email } from "@validations";
import formDirtyMixin from "@/mixins/formDirtyMixin";
import MultiSelect from "vue-multiselect";
import { name } from "file-loader";
import usersStoreMixin from "@/mixins/usersStoreMixin";

export default {
  components: {
    TextInput,
    ValidationProvider,
    ValidationObserver,
    MultiSelect,
    MultiSelectInput,
  },
  mixins: [formDirtyMixin, usersStoreMixin],

  computed: {
    ...mapGetters("users", ["users"]),
    modifiedUsers() {
      return this.users.map((user) => ({
        ...user,
        full_name: `${user.first_name} ${user.last_name}`,
      }));
    },
    columns() {
      const cols = [
        {
          label: this.$t("name"),
          field: "name",
        },
        {
          label: this.$t("tags"),
          field: "tags",
        },
        {
          label: this.$t("users"),
          field: "users",
          sortable: false,
        },
        {
          label: this.$t("link"),
          field: "link",
          sortable: false,
        },
        {
          label: this.$t("status"),
          field: "isActivate",
        },
      ];

      // Conditionally add "action" column
      if (!this.isShow) {
        cols.push({
          tdClass: "vgt-center-align",
          thClass: "vgt-center-align",
          label: this.$t("action"),
          field: "action",
          sortable: false,
        });
      }

      return cols;
    },
    isReferralLinkFormInvalid() {
      return !this.referralLinks.name;
    },
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    search() {
      this.debouncedFetch();
    },
    filterTags() {
      this.debouncedFetch();
    },
    form: {
      handler(newVal) {
        this.isFormDirty = JSON.stringify(newVal) !== this.originalForm;
      },
      deep: true,
    },
  },
  created() {
    this.debouncedFetch = debounce(async (newValue, oldValue) => {
      try {
        await this.loadItems();
      } catch (e) {
        console.error(e);
      }
    }, 300);
  },
  data() {
    return {
      originalForm: null,
      referralLinks: {
        name: "",
        tags: [],
        users: [],
        isActivate: true,
      },
      tags: [],
      filterTags: [],
      search: "",
      referralServiceBaseUrl: process.env.VUE_APP_REFERRAL_BASEURL || "",
      totalRecords: 0,
      pageLength: 25,
      page: 1,
      rows: [],
      showModal: false,
      searchTerm: "",
      sortBy: "createdAt",
      sortOrder: "desc",
      modalType: "add",
      image: {},
    };
  },
  async mounted() {
    if (!this.isShow) await this.$store.dispatch("users/list");
    this.loadItems();
  },
  methods: {
    formatTags(tags) {
      if (!tags) return [];

      if (Array.isArray(tags)) {
        return tags.map((tag) => tag.name || tag); // Handle [{ name: 'x' }, { name: 'y' }]
      }

      // If it's a comma-separated string
      return tags.split(",").map((tag) => tag.trim());
    },
    async addTag(newTag) {
      if (!Array.isArray(this.referralLinks.tags)) {
        this.referralLinks.tags = [];
      }
      const tags = newTag
        .split(",")
        .map((tag) => tag.trim())
        .filter((tag) => tag !== "");

      tags.forEach((tag) => {
        const exists = this.referralLinks.tags.some(
          (t) => t.name.toLowerCase() === tag.toLowerCase()
        );
        if (!exists) {
          this.referralLinks.tags.push({ name: tag });
        }
      });
    },
    copyToClipboard(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$toast.success(this.$t("linkCopiedToClipboard"), {
            position: "bottom-right",
          });
        })
        .catch((err) => {
          console.error("Copy failed", err);
        });
    },
    async saveReferralLink() {
      this.$refs.referralLinkRules.validate().then(async (success) => {
        if (success) {
          // Convert array to comma-separated string
          const tagString = this.referralLinks.tags
            .map((tag) => tag.name)
            .join(",");

          this.$store.commit("showLoader", true);
          await this.$store
            .dispatch("referralLinks/create", {
              ...this.referralLinks,
              tags: tagString,
              users: this.referralLinks.users.map((user) => user.id),
            })
            .then(async (res) => {
              this.showModal = false;
              this.referralLinks = {
                name: "",
                tags: [],
                users: [],
                isActivate: true,
              };
            })
            .finally(() => {
              this.$store.commit("showLoader", false);
              this.loadItems();
            });
        }
      });
    },
    async editReferralLink() {
      this.$refs.referralLinkRules.validate().then(async (success) => {
        if (success) {
          const tagString = this.referralLinks.tags
            .map((tag) => tag.name)
            .join(",");

          this.$store.commit("showLoader", true);
          await this.$store
            .dispatch("referralLinks/update", {
              id: this.selectedId,
              data: {
                ...this.referralLinks,
                tags: tagString,
                users: this.referralLinks.users.map((user) => user.id),
              },
            })
            .then(async (res) => {
              this.showModal = false;
              this.referralLinks = {
                name: "",
                tags: [],
                users: [],
                isActivate: true,
              };
            })
            .finally(() => {
              this.$store.commit("showLoader", false);
              this.loadItems();
            });
        }
      });
    },
    onSortChange(params) {
      this.sortOrder = params[0].type;
      if (params[0].type == "none") this.sortOrder = "asc";

      this.sortBy = params[0].field;
      this.loadItems();
    },
    onPerPageChange(params) {
      this.updateParams({ pageLength: params.pageLength });
      this.loadItems();
    },
    onPageChange(params) {
      this.page = params.currentPage;
      this.loadItems();
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this, newProps);
    },
    openModal(type, item = null) {
      this.referralLinks = {
        name: "",
        tags: [],
        users: [],
        isActivate: true,
      };

      this.modalType = type;

      if (type === "edit" && item) {
        const selectedUsers = [];
        if (item.users && Array.isArray(item.users)) {
          for (const user of item.users) {
            const profile = this.userProfiles[user.userId];
            if (profile) {
              selectedUsers.push({
                ...profile,
                full_name: `${profile.first_name} ${profile.last_name}`.trim(),
              });
            }
          }
        }
        this.selectedId = item.id;

        this.referralLinks = {
          name: item.name,
          tags:
            typeof item.tags === "string"
              ? item.tags.split(",").map((tag) => ({ name: tag.trim() }))
              : item.tags || [], // fallback if already an array
          users: selectedUsers,
          isActivate: item.isActivate,
        };
      }

      this.showModal = true;
    },

    async loadItems() {
      try {
        const selectedTags = this.filterTags.map((tag) => tag.name);
        const companyId = this.$route?.params?.id;
        this.$store.commit("showLoader", true);

        let response = await this.$store.dispatch("referralLinks/list", {
          page: this.page,
          filterTags: selectedTags,
          search: this.search,
          perPage: this.pageLength,
          sortBy: this.sortBy,
          sortOrder: this.sortOrder,
          ...(companyId ? { companyId } : {}), // Conditionally add companyId
        });
        this.rows = response?.data?.data;
        this.totalRecords = response?.data?.total;
        this.tags = response?.data?.tags;
        const userIds = Array.from(
          new Set(
            this.rows.flatMap((row) => row.users.map((user) => user.userId))
          )
        );
        await this.getUserProfiles(userIds);
      } catch (e) {
        console.error("api error ___", e);
      } finally {
        this.$store.commit("showLoader", false);
      }
    },
    async destroy(id) {
      const confirmed = await this.showConfirmationDialog({
        title: this.$t("doYouWantToDeleteThisRecord"),
        subText: this.$t("yesDeleteIt"),
      });

      if (confirmed) {
        this.$store.commit("showLoader", true);
        await this.$store.dispatch("referralLinks/destroy", id).finally(() => {
          this.$store.commit("showLoader", false);
          this.loadItems();
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#nprogress {
  position: relative;
  z-index: 9999999;
}

.white-color {
  color: white !important;
}

.vgt-responsive {
  overflow-x: visible !important;
}

.news-image {
  margin-top: 10px;
  img {
    width: 200px;
    object-fit: contain;
    border: 1px solid rgba(255, 255, 255, 0.2);
    padding: 5px;
    border-radius: 5px;
  }

  .user-name {
    margin-right: 8px;
    color: #555;
    font-size: 0.9rem;
    cursor: default;
    transition: color 0.2s, text-decoration 0.2s;
  }

  .user-name:hover {
    text-decoration: underline;
    color: #333;
  }

  .separator {
    margin: 0 4px;
    color: #999;
  }
}
</style>
